import { styled } from 'baseui'

export const Card = styled('div', ({ $theme }) => ({
  marginBottom: '1rem',
  backgroundColor: $theme.colors.bg100,
  paddingTop: '1rem',
  paddingRight: '1rem',
  paddingBottom: '1rem',
  paddingLeft: '1rem',
  borderRadius: $theme.borders.radius400,
  boxShadow: $theme.lighting.shadow400,
}))

export const Title = styled('h2', ({ $theme }) => ({
  color: $theme.colors.primary,
  ...$theme.typography.font650,
}))

export const Columns = styled('div', () => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  '@media screen and (min-width: 1200px)': {
    flexDirection: 'row',
  },
}))

export const Column = styled('div', () => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  marginBottom: '1rem',
  marginLeft: '1rem',
  ':last-child': {
    flexDirection: 'column-reverse',
    justifyContent: 'space-between',
    marginLeft: '1rem',
  },
  '@media screen and (min-width: 1200px)': {
    width: '100%',
    marginLeft: '1rem',
  },
}))

export const ValidationCard = styled('div', ({ $theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  marginBottom: '1rem',
  paddingTop: '1rem',
  paddingRight: '1rem',
  paddingBottom: '1rem',
  paddingLeft: '1rem',
  backgroundColor: $theme.colors.bg050,
  borderRadius: $theme.borders.radius200,
  boxShadow: $theme.lighting.shadow400,
}))

export const ValidationTitle = styled('h3', ({ $theme }) => ({
  color: $theme.colors.primary,
  ...$theme.typography.font650,
  fontSize: $theme.typography.ParagraphSmall.fontSize,
  lineHeight: $theme.typography.ParagraphSmall.lineHeight,
}))

export const ValidationBadge = styled('div', ({ $theme, status }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: '.5rem',
  paddingTop: '.125rem',
  paddingRight: '.125rem',
  paddingBottom: '.125rem',
  paddingLeft: '.125rem',
  borderRadius: $theme.borders.radius100,
  ...$theme.typography.font650,
  fontSize: $theme.typography.ParagraphSmall.fontSize,
  lineHeight: $theme.typography.ParagraphSmall.lineHeight,
  color: status === 'valid' ? $theme.colors.positive600 : $theme.colors.negative600,
  textAlign: 'center',
  backgroundColor: status === 'valid' ? $theme.colors.positive200 : $theme.colors.negative200,
  border: `solid 1px ${status === 'valid' ? $theme.colors.positive600 : $theme.colors.negative600}`,
  ':last-child': {
    marginTop: '0',
    marginBottom: '0',
    marginLeft: '0',
    marginRight: '0',
  },
}))

export const tabsOverrides = isAdded => ({
  Root: {
    style: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
  },
  TabList: {
    style: {
      width: '100%',
      fontSize: '1rem',
    },
  },
  TabHighlight: {
    style: ({ $theme }) => ({
      display: 'none',
    }),
  },
  TabBorder: {
    style: ({ $theme }) => ({
      display: 'none',
    }),
  },
})

export const tabOverrides = (isSelected, isAdded) => ({
  Tab: {
    style: ({ $theme }) => ({
      'justify-content': 'start',
      backgroundColor: isSelected ? (isAdded ? $theme.colors.positive150 : $theme.colors.bg150) : $theme.colors.bg100,
      borderRadius: '.5rem 0 0 .5rem',
      outlineOffset: '-2px',
      ...$theme.typography.font550,
      fontSize: '.7rem',
      paddingTop: '.5rem',
      paddingRight: '.5rem',
      paddingBottom: '.5rem',
      paddingLeft: '1rem',
      color: isAdded ? $theme.colors.positive500 : isSelected ? $theme.colors.primary : $theme.colors.mono800,
      ':hover': {
        outline: `2px ${isAdded ? $theme.colors.positive500 : $theme.colors.primary} solid`,
        backgroundColor: $theme.colors.bg10,
      },
      '@media screen and (min-width: 800px)': {
        fontSize: '0.70rem',
      },
      '@media screen and (min-width: 1200px)': {
        fontSize: '0.75rem',
      },
      '@media screen and (min-width: 1400px)': {
        fontSize: '0.85rem',
      },
    }),
  },

  TabPanel: {
    style: () => ({
      paddingTop: '0',
      paddingRight: '0',
      paddingBottom: '0',
      paddingLeft: '0',
      '@media screen and (min-width: 1200px)': {
        width: '67%',
      },
    }),
  },

  ArtworkContainer: {
    style: () => ({
      marginRight: '.25rem',
    }),
  },
})

export const ProviderOverrides = () => ({
  Svg: {
    style: () => ({
      marginLeft: '.25rem',
    }),
  },
})

export const InfoDepartmentOverrides = () => ({
  Svg: {
    style: () => ({
      marginLeft: '-1.25rem',
    }),
  },
})

export const IconOverrides = () => ({
  Svg: {
    style: () => ({
      marginRight: '.25rem',
    }),
  },
})

export const RetryConfirmationList = styled('div', () => ({
  display: 'flex',
  flexDirection: 'column',
  rowGap: '0.5rem',
  marginTop: '1rem',
}))

export const RetryHelperText = styled('div', () => ({
  fontSize: '0.875rem',
}))

export const RetryProgress = styled('div', () => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  rowGap: '1rem',
}))

export const ConfirmModalMessage = styled('p', () => ({
  margin: 0,
}))

export const ConfirmModalActions = styled('div', () => ({
  marginTop: '1rem',
  display: 'flex',
  gap: '0.5rem',
  justifyContent: 'center',
}))

export const confirmModalOverrides = {
  Dialog: {
    style: () => ({
      minHeight: 'auto',
      '@media screen and (min-width: 768px)': {
        width: '36rem',
        minHeight: 'auto',
      },
    }),
  },
}

export const SignatureStepsCard = styled('div', ({ $theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.75rem',
  width: '100%',
  boxSizing: 'border-box',
  marginBottom: '1rem',
  padding: '1rem',
  backgroundColor: $theme.colors.primary50,
  borderRadius: $theme.borders.radius300,
}))

export const SignatureStep = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '0.75rem',
})

export const SignatureStepIcon = styled('span', {
  display: 'flex',
  flexShrink: 0,
})

const signatureStepColor = ($theme, $isLoading, $isFailed) => {
  if ($isLoading) return $theme.colors.primary
  if ($isFailed) return $theme.colors.negative

  return $theme.colors.positive
}

export const SignatureStepLabel = styled('span', ({ $theme, $isLoading, $isFailed }) => ({
  fontSize: '0.95rem',
  color: signatureStepColor($theme, $isLoading, $isFailed),
}))

export const SignatureStepsHint = styled('div', ({ $theme }) => ({
  boxSizing: 'border-box',
  marginTop: '0.25rem',
  padding: '0.5rem 0.75rem',
  backgroundColor: $theme.colors.white,
  borderRadius: $theme.borders.radius200,
  color: $theme.colors.primary600,
  fontSize: '0.85rem',
  textAlign: 'center',
}))
